import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "company" }
const _hoisted_3 = { class: "service" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "tag" }
const _hoisted_6 = { class: "date" }
const _hoisted_7 = { class: "date-key" }
const _hoisted_8 = { class: "date-value" }

import { computed } from 'vue'
import { useRouter } from 'vue-router';
import { useRequestStore } from '@/stores/request';
import { getTagColor } from '@/utils'
import { getPaymentTypeValue, getPaymentCycleTypeValue, getDocumentTypeValue }  from '@/utils/getValueForKey'
import { RequestOnBoard } from '@/types/Request'
import moment from 'moment';
import StatusTag from '@/components/StatusTag.vue'
import IconBeusGray from '@/assets/images/ico-beus-g.svg'
import IconBiGray from '@/assets/images/ico-bi-g.svg'
import IconPVGray from '@/assets/images/ico-pv-g.svg'
import IconJamGray from '@/assets/images/ico-jam-g.svg'
import IconServiceGray from '@/assets/images/ico-service-g.svg'

interface Props {
  status: string,
  data: RequestOnBoard
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BoardStateItem',
  props: {
    status: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();
const requestStore = useRequestStore();

const navigateWithData = (requestId: string, subId: string, status: string) => {
  requestStore.setRequestIds(requestId, subId);
  router.push(`/request/viewStat/${requestId}/${status}`);
};

const arrDisplayPaymentType = [
  'CREATED_REQUEST_PLAN', 
  'CREATED_REQUEST_PV',
  'CREATED_REQUEST_JAM',
  'CREATED_REQUEST_ADDITIONAL',
  'DAY_PAYMENT_WIRE',
  'DAY_PAYMENT_WIRE_DELAY',
  'DAY_PAYMENT_CARD',
  'NEED_TO_EXTEND'
]

const arrDisplayDocumentType = [
  'DAY_INVOICE_TAX', 
  'DAY_INVOICE'
]

const icons = [
  {
    condition: () => props.data.options.requestType === 'PLAN' && props.data.options.beusPlanNumber,
    src: IconBeusGray,
    alt: '플랜-히트맵',
  },
  {
    condition: () => props.data.options.requestType === 'PLAN' && props.data.options.baPlanNumber,
    src: IconBiGray,
    alt: '플랜-저니맵',
  },
  {
    condition: () => props.data.options.requestType === 'PV_CHARGE',
    src: IconPVGray,
    alt: 'PV 충전',
  },
  {
    condition: () => props.data.options.requestType === 'JAM_CHARGE',
    src: IconJamGray,
    alt: 'JAM 충전',
  },
  {
    condition: () => props.data.options.requestType === 'ADDITIONAL',
    src: IconServiceGray,
    alt: '부가서비스',
  },
];

const filteredIcons = computed(() =>
  icons.filter((icon) => icon.condition())
);

const statusTags = computed(() => [
  { // 결제 유형
    condition: arrDisplayPaymentType.includes(props.status),
    text: getPaymentTypeValue(props.data.options.paymentType),
  },
  { // 사용 기간 (N개월)
    condition: props.data.options.period && arrDisplayPaymentType.includes(props.status),
    text: `${props.data.options.period}개월`,
  },
  { // 결제 주기
    condition: props.data.options.paymentCycle && !arrDisplayDocumentType.includes(props.status),
    text: props.data.options.paymentCycle ? getPaymentCycleTypeValue(props.data.options.paymentCycle): '',
  },
  { // 자동 갱신 여부
    condition: props.data.options.recurring && arrDisplayPaymentType.includes(props.status),
    text: "자동갱신",
  },
  { // 서류명
    condition: arrDisplayDocumentType.includes(props.status),
    text: props.data.options.docType ? getDocumentTypeValue(props.data.options.docType): ''
  },
]);

const filteredStatusTags = computed(() => {
  return statusTags.value.filter(tag => tag.condition);
});

const getDateLabel = (status: string) => {
  if (getTagColor(status) === 'blue') return '사용 시작일';
  if (getTagColor(status) === 'purple') return '결제일';
  if (getTagColor(status) === 'pink') return '발행일';
  if (getTagColor(status) === 'rose') return '플랜 종료일';
}

const isWarning = computed(() => { 
  const today = moment().format('YYYY-MM-DD');
  const dataDate = moment(props.data.date).format('YYYY-MM-DD');

  return props.status === 'DAY_PAYMENT_WIRE_DELAY' || dataDate < today
    ? 'is-warning'
    : false;
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["state-item", isWarning.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("strong", _hoisted_2, _toDisplayString(_ctx.data.companyName), 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredIcons.value, (icon, index) => {
          return (_openBlock(), _createElementBlock("img", {
            key: index,
            src: icon.src,
            alt: icon.alt
          }, null, 8, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredStatusTags.value, (tag, index) => {
        return (_openBlock(), _createBlock(StatusTag, {
          key: index,
          color: _unref(getTagColor)(_ctx.status),
          size: "small",
          text: tag.text
        }, null, 8, ["color", "text"]))
      }), 128)),
      (_ctx.data.options.tasks?.SENT_MAIL_EXTEND || _ctx.data.options.tasks?.SENT_REMIND_MAIL)
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            icon: `fa-solid fa-envelope${_ctx.data.options.tasks?.CONFIRMED_REPLY ? '-circle-check': ''}`,
            size: "lg",
            style: _normalizeStyle({ color: _ctx.data.options.tasks?.SENT_MAIL_EXTEND ? '#C11574' : '#5925DC' })
          }, null, 8, ["icon", "style"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", _hoisted_7, _toDisplayString(getDateLabel(_ctx.status)), 1),
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.data.date), 1)
    ]),
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (navigateWithData(_ctx.data.requestId, _ctx.data.subId, _ctx.status)), ["prevent"])),
      class: "link"
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("span", { class: "blind" }, "자세히", -1)
    ]))
  ], 2))
}
}

})